import { createStyles } from '@material-ui/core';

const styles = () =>
  createStyles({
    draggableItemContainer: {
      alignItems: 'center',
      justifyContent: 'space-between',
      width: '100%',
    },
    image: {
      width: 36,
      aspectRatio: 4 / 5,
      objectFit: 'cover',
      borderRadius: 4,
    },
  });

export default styles;
